//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import SocietyFloat from '../societyFloat/societyFloat.vue'
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import { Toast } from 'vant'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
export default {
  name: "home",
  data() {
    let that = this
    return {
      acct:1,
      sw:null,
      userInfo: this.$store.getters.getUserInfo,
      value: "",
	  content1: "",
	  societyInfo: {},
	  societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId :  window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
	  societyName: (this.$route.query.societyName != null && this.$route.query.societyName != '' ) ? this.$route.query.societyName : window.localStorage.getItem('societyName'),
	  logoImgUrl: (this.$route.query.logoImgUrl != undefined && this.$route.query.logoImgUrl != null && this.$route.query.logoImgUrl != '' ) ? this.$route.query.logoImgUrl : window.localStorage.getItem('logoImgUrl'),
    }
  },
  activated () {
    this.userInfo = this.$store.getters.getUserInfo
  },
  directives: {
  },
  components: { Header, Footer, SocietyFloat },
  computed: {
  },
  destroyed(){
  },

  methods: {
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    showAcct(params){
      this.acct = params
	  if(params == 1){
		  this.content1 = this.societyInfo.xhSynopsis
	  }else if(params == 2){
		  this.content1 = this.societyInfo.xhRules
	  }else{
		  this.content1 = this.societyInfo.xhZzjg
	  }
    },
	//跳转到机构主页
	fnGoToSocietyIndexPage(e){
	  this.fnStopBub(e);
	  this.$router.push({path: '/societyIndex', query: {societyId:this.societyId}});
	},
    fnInitData(){
	  let that = this;
	  let obj = new Object();
	  obj.id = that.societyId;
	  requestByPost(API.selSocietyInfoById,JSON.stringify(obj)).then((res)=>{
		if(res.data != undefined && res.data.obj != undefined && res.data.obj != null ){
		  that.societyInfo = res.data.obj;
		  that.content1 = that.societyInfo.xhSynopsis
		}else{
		  that.societyInfo = {};
		}
	  })
    }
  },
  mounted() {
    document.title = "觅圈圈";
    $$(document).scroll(function(){
      var y = $$(document).scrollTop()
      console.log()
      if(y >= 100){
          $(".newindextop").addClass("newindextop1").css({"top":0})
      }else{
         $(".newindextop").removeClass("newindextop1").css({"top":"inherit"})
      }
    })
    // this.goto()
  },
  created() {
	let that = this;
	that.$store.commit('home/setShowMenuType', 1);//机构菜单
	// that.$store.commit('home/setSocietyLogoUrl', that.logoImgUrl);
	that.$store.commit('home/setMenuJgActive', 1);//机构菜单选中哪个
	that.fnInitData()
  },

  updated(){

  }

};



// WEBPACK FOOTER //
// ./src/pages/society/societyAbout.vue